class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    // === HOVER + CLICK NAV START ===
    // Top level: hover to open
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      clearTimeout(this._hoverTimer);
      this.mainDetailsToggle.setAttribute('open', '');
    });
    this.mainDetailsToggle.addEventListener('mouseleave', () => {
      this._hoverTimer = setTimeout(() => {
        this.mainDetailsToggle.removeAttribute('open');
      }, 150);
    });

    // Top level: click summary → navigate to parent link
    const summary = this.mainDetailsToggle.querySelector(':scope > summary');
    if (summary) {
      const parentLink = summary.querySelector('a');
      const parentUrl = parentLink ? parentLink.href : null;
      summary.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: hover)').matches && parentUrl) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = parentUrl;
        }
      }, true); // capture phase = runs before other handlers
    }

    // Second level (Ebike/Etrike/Parts): hover to open + click to navigate
    this.mainDetailsToggle.querySelectorAll('.mega-menu__child-dropdown').forEach((child) => {
      const childSummary = child.querySelector(':scope > summary');
      if (!childSummary) return;

      child.addEventListener('mouseenter', () => {
        clearTimeout(child._timer);
        child.setAttribute('open', '');
      });
      child.addEventListener('mouseleave', () => {
        child._timer = setTimeout(() => child.removeAttribute('open'), 150);
      });

      childSummary.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: hover)').matches) {
          const href = childSummary.dataset.url;
          if (href && href !== '#') {
            e.preventDefault();
            e.stopImmediatePropagation();
            window.location.href = href;
          }
        }
      }, true);
    });
    // === HOVER + CLICK NAV END ===
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
